import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import AppNotification from 'types/app_notification'
import { mergeURL } from './lib'

const resource = 'notifications'

export const requests = {
  fetchIndex: async (page: number, limit: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<AppNotification[]>>(
      resource,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
  fetchUnreadCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<{ total: number }>>(
      `${resource}/unread_count`,
    )
  },
  read: async (id: number) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      mergeURL(resource, `read/${id.toString()}`),
    )
  },
}
